import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { DashboardLayout } from "@/components/DashboardLayout";
import { STATUS_COLORS } from "@/lib/constants";
import api from "@/lib/api";

export default function AdminReferrals() {
  const [refs, setRefs] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    api.get("/meta").then((r) => setStatuses(r.data.statuses)).catch(() => {});
  }, []);
  useEffect(() => {
    api.get("/admin/referrals", { params: filter ? { status: filter } : {} }).then((r) => setRefs(r.data)).catch(() => {});
  }, [filter]);

  return (
    <DashboardLayout title="Segnalazioni" admin>
      <div className="flex flex-wrap items-center gap-2 mb-5">
        <button onClick={() => setFilter("")} className={`rounded-full px-4 py-2 text-sm font-medium ${!filter ? "bg-[#0A1128] text-white" : "bg-white border border-slate-200 text-slate-600"}`}>Tutte</button>
        {statuses.map((s) => (
          <button key={s.key} onClick={() => setFilter(s.key)} data-testid={`filter-${s.key}`}
            className={`rounded-full px-4 py-2 text-sm font-medium ${filter === s.key ? "bg-[#0A1128] text-white" : "bg-white border border-slate-200 text-slate-600"}`}>
            {s.label}
          </button>
        ))}
      </div>

      <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden">
        <div className="hidden sm:grid grid-cols-12 gap-4 px-5 py-3 bg-slate-50 text-xs font-semibold text-slate-500 uppercase">
          <span className="col-span-2">Codice</span>
          <span className="col-span-3">Proprietario</span>
          <span className="col-span-3">Immobile</span>
          <span className="col-span-2">Segnalatore</span>
          <span className="col-span-2">Stato</span>
        </div>
        {refs.length === 0 && <p className="p-8 text-center text-slate-400">Nessuna segnalazione.</p>}
        {refs.map((r) => (
          <Link key={r.id} to={`/admin/segnalazioni/${r.id}`} data-testid={`admin-referral-${r.code}`}
            className="grid grid-cols-2 sm:grid-cols-12 gap-2 sm:gap-4 px-5 py-4 border-b border-slate-100 last:border-0 hover:bg-slate-50 items-center">
            <span className="col-span-2 font-mono text-sm font-semibold text-slate-900 flex items-center gap-2">
              {r.code}
              {r.flagged_duplicate && <AlertTriangle className="h-4 w-4 text-amber-500" title="Possibile duplicato" />}
            </span>
            <span className="col-span-3 text-sm text-slate-700 truncate">{r.owner_name}<br /><span className="text-xs text-slate-400">{r.owner_phone}</span></span>
            <span className="col-span-3 text-sm text-slate-600 truncate">{r.property_type} · {r.comune}</span>
            <span className="col-span-2 text-sm text-slate-500 truncate">{r.reporter_name}</span>
            <span className="col-span-2"><span className={`rounded-full px-2.5 py-1 text-xs font-medium ${STATUS_COLORS[r.status] || "bg-slate-100"}`}>{r.status_label}</span></span>
          </Link>
        ))}
      </div>
    </DashboardLayout>
  );
}
